import React, { Fragment } from "react"
import { Helmet } from "react-helmet"

import PageTitle from "ui/components/PageTitle"
import WithPages from "data/wrappers/WithPages"
import WithApps from "data/wrappers/WithApps"
import WithBlocks from "data/wrappers/WithBlocks"

import Page from "../editor/page"
import { TreeInstance } from "../editor/tree/tree"
import fakeTrees from "../editor/defaultTree"
import WithActions from "data/wrappers/WithActions"
const { realBlocks, emptyPage } = fakeTrees

export default class ViewPageFromUrl extends React.Component {
    render() {
        const route = this.props.params.splat

        return (
            <WithActions>
                {() => (
                    <WithBlocks>
                        {() => (
                            <WithApps>
                                {({ apps }) => {
                                    // greedily match to an app

                                    let pageUrl
                                    let appUrl = "/" + route.split("/")[0]
                                    let appMatches = apps.filter(app => app.url === appUrl)
                                    if (!appMatches.length) {
                                        appMatches = apps.filter(app => app.url === "/")
                                        pageUrl = "/" + route
                                    } else {
                                        pageUrl =
                                            "/" +
                                            route
                                                .split("/")
                                                .slice(1)
                                                .join("/")
                                    }

                                    return appMatches.map(app => (
                                        <WithPages>
                                            {({ pages }) => {
                                                // See if we have any url params
                                                // console.log("Matching to pageUrl", pageUrl)
                                                const dbPageUrltoRegex = page => {
                                                    var captures = page.match(
                                                        new RegExp("{.+?}", "g")
                                                    )
                                                    var query = page
                                                    if (captures)
                                                        captures.forEach(
                                                            capture =>
                                                                (query = query.replace(
                                                                    capture,
                                                                    "(.+?)"
                                                                ))
                                                        )

                                                    // console.log("matching against ", query)
                                                    const regex = "^" + query + "$"
                                                    return { regex, captures }
                                                }

                                                const filterPageByReg = page => {
                                                    const { regex, captures } = dbPageUrltoRegex(
                                                        page.url
                                                    )
                                                    const results = pageUrl.match(new RegExp(regex))
                                                    // console.log("trying to match to regex", regex, "got ", results)
                                                    return !!results
                                                }

                                                let matches = pages
                                                    .filter(page => page.app_id === app._sid)
                                                    .filter(filterPageByReg)

                                                if (!matches.length) return ""

                                                const page = matches[0]
                                                // console.log("found page ", page)
                                                const { regex, captures } = dbPageUrltoRegex(
                                                    page.url
                                                )

                                                const captureResults = pageUrl.match(
                                                    new RegExp(regex)
                                                )
                                                var captureDict = {}
                                                if (captures)
                                                    captures.forEach((label, i) => {
                                                        let cleanLabel = label.slice(
                                                            1,
                                                            label.length - 1
                                                        )
                                                        captureDict[cleanLabel] =
                                                            captureResults[i + 1]
                                                    })

                                                const tree = isValidTree(page.blocks)
                                                    ? new TreeInstance(
                                                          JSON.parse(JSON.stringify(page.blocks))
                                                      )
                                                    : emptyPage
                                                return (
                                                    <Fragment>
                                                        <Helmet>
                                                            <meta charSet="utf-8" />
                                                            <title>
                                                                {page.options.title || page.name}
                                                            </title>
                                                            <link
                                                                rel="shortcut icon"
                                                                href={`${page.options.favicon}`}
                                                                type="image/png"
                                                            />
                                                        </Helmet>
                                                        <Page
                                                            key={page._sid}
                                                            page={page}
                                                            urlCaptures={captureDict}
                                                            tree={tree}
                                                            allowEdits={false}
                                                        />
                                                    </Fragment>
                                                )
                                            }}
                                        </WithPages>
                                    ))
                                }}
                            </WithApps>
                        )}
                    </WithBlocks>
                )}
            </WithActions>
        )

        // This component needs to pull out the relevant page from the DB,
        // if it has permission to depending on the logged-in user
    }
}

const isValidTree = obj => Array.isArray(obj)



// WEBPACK FOOTER //
// ./src/features/pages/ViewPageFromUrl.js